export default [
  {
    title: "Ana Sayfa",
    to: { name: "root" },
    icon: { icon: "tabler-smart-home" },
    yetki: { k: [] },
  },
  {
    title: "Kullanıcılar",
    to: { name: "kullanicilar" },
    icon: { icon: "tabler-users-group" },
    yetki: { k: [], a: true },
  },
  {
    title: "Siparisler",
    to: { name: "siparisler" },
    icon: { icon: "tabler-credit-card-pay" },
    yetki: { k: [], a: true },
  },
  {
    title: "Ödeme Tip",
    to: { name: "odeme_yontemi" },
    icon: { icon: "tabler-credit-card-pay" },
    yetki: { k: [], a: true },
  },
  {
    title: "Düğün Tanıtım",
    to: { name: "dugun_tanitim" },
    icon: { icon: "wpf--wedding-cake" },
    yetki: { k: [], a: true },
  },
  {
    title: "Paket Tanıtım",
    to: { name: "paket_tanitim" },
    icon: { icon: "tabler-package" },
    yetki: { k: [], a: true },
  },
  {
    title: "Parametre",
    to: { name: "parametre" },
    icon: { icon: "tabler-settings" },
    yetki: { k: [], a: true },
  },
];
